import { Icon } from '#app/components/ui/icon.tsx'
import { Tag } from '#app/components/ui/tag.tsx'

interface ObjectiveCardProps {
	icon: 'briefcase-09' | 'eco-power' | 'fire' | 'document-validation' | 'sun'
	title: string
}

function ObjectiveCard({ icon, title }: ObjectiveCardProps) {
	return (
		<div className="flex flex-1 flex-col gap-6 rounded-xl border border-neutral-200 bg-neutral-100 p-6">
			{/* Icon Container */}
			<div className="flex h-11 w-11 items-center justify-center rounded-[24px] bg-blue-800 p-2.5">
				<Icon name={icon} className="h-6 w-6 text-white" />
			</div>

			{/* Content */}
			<div className="flex flex-col gap-3">
				<p className="font-parkinsans text-txt-primary text-base leading-5 font-medium">
					{title}
				</p>
			</div>
		</div>
	)
}

interface ObjectivesSectionProps {
	className?: string
}

export function ObjectivesSection({ className }: ObjectivesSectionProps) {
	const objectives = [
		{
			icon: 'generar-icon' as const,
			title: 'Generar acciones medibles de mitigación y adaptación.',
		},
		{
			icon: 'eco-power' as const,
			title: 'Restaurar ecosistemas claves de nuestro país.',
		},
		{
			icon: 'promover' as const,
			title: 'Promover la transición energética en escuelas con energía solar.',
		},
		{
			icon: 'educ-icon' as const,
			title: 'Educar sobre el cambio climático y sus efectos locales.',
		},
		{
			icon: 'sun' as const,
			title: 'Fomentar hábitos sostenibles y conciencia colectiva.',
		},
	]

	return (
		<section className={`px-[37.5px] py-8 md:px-4 ${className || ''}`}>
			<div className="rounded-[24px] bg-gradient-to-r from-blue-500 to-green-500 px-6 py-16 md:px-24 md:pt-16 md:pb-[104px]">
				{/* Tag */}

				<div className="mx-auto max-w-[1200px]">
					<div className="mb-14">
						<Tag
							variant="secondary"
							appearance="solid"
							color="green"
							size="l"
							option="text-icon-left"
							leftIcon="service"
						>
							Propósito
						</Tag>
					</div>

					{/* Content Wrapper */}

					<div className="flex flex-col gap-14 md:gap-24">
						{/* Title */}
						<h2 className="font-parkinsans text-[32px] leading-[48px] font-medium text-white md:text-5xl md:leading-[64px]">
							Objetivos principales
						</h2>

						{/* Objectives Grid */}
						<div className="flex flex-col gap-4 md:flex-row">
							{objectives.map((objective, index) => (
								<ObjectiveCard
									key={index}
									icon={objective.icon}
									title={objective.title}
								/>
							))}
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default ObjectivesSection
